import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { useWorld } from "@/context/WorldContext";
import { fileUrl } from "@/lib/api";
import { CARD_H, CARD_W } from "@/lib/family";
import { speciesMembers, speciesStatus } from "@/lib/infobox";
import { SpeciesStatusBadge } from "@/components/SpeciesBits";

const initials = (t) => t.split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const SpeciesNode = ({ page, p, i, dim, onHover, pannable, focused }) => {
  const { pages, basePath } = useWorld();
  const status = speciesStatus(page);
  const n = speciesMembers(pages, page.id).length;
  return (
    <Link to={`${basePath}/p/${page.id}`} onPointerDown={pannable ? undefined : (e) => e.stopPropagation()} draggable={false} onMouseEnter={() => onHover(page.id)} onMouseLeave={() => onHover(null)}
      data-testid={`tol-node-${page.id}`} data-extinct={status === "Extinct"} data-focused={!!focused}
      style={{ left: p.x, top: p.y, width: CARD_W, height: CARD_H, animationDelay: `${Math.min(i, 20) * 35}ms` }}
      className={`rise absolute rounded-xl border bg-panel flex flex-col items-center justify-center gap-1 px-2 transition-[opacity,border-color] duration-300 hover:border-sky-400/70 ${
        focused ? "border-sky-300 ring-2 ring-sky-400/40 shadow-[0_0_30px_-6px_rgba(56,189,248,0.6)]" : status === "Extinct" ? "border-dashed border-stone-500/40" : "border-sky-500/25"} ${dim ? "opacity-25" : status === "Extinct" ? "opacity-70" : ""}`}>
      {page.image ? <img src={fileUrl(page.image)} alt="" className={`w-10 h-10 rounded-full object-cover ring-1 ring-sky-500/40 ${status === "Extinct" ? "grayscale" : ""}`} />
        : <div className="w-10 h-10 rounded-full bg-sky-500/10 text-sky-200 font-display text-base flex items-center justify-center">{initials(page.title)}</div>}
      <span className="font-display text-[15px] leading-tight text-center text-slate-100 line-clamp-1 w-full" data-testid={`tol-node-name-${page.id}`}>{page.title}</span>
      <SpeciesStatusBadge status={status} />
      <span className="flex items-center gap-1 text-[10px] font-code text-slate-500" data-testid={`tol-node-members-${page.id}`}><Users className="w-3 h-3" />{n}</span>
    </Link>
  );
};
